import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { EditorContent } from "@tiptap/react";
import { generateHTML } from "@tiptap/html";
import { useEffect, useState } from "react";
import canUseDOM from "dom-helpers/canUseDOM";
import EditorWrapper from "./EditorWrapper";
import SelectionMenu from "./components/SelectionMenu";
const Editor = (props)=>{
    const { editor , className , initialState , extensions , placeholder  } = props;
    const [mount, setMount] = useState(()=>canUseDOM);
    useEffect(()=>{
        setMount(true);
    }, []);
    // ssr
    if (!mount) return /*#__PURE__*/ _jsx(EditorWrapper, {
        className: className,
        children: /*#__PURE__*/ _jsx("div", {
            children: initialState ? /*#__PURE__*/ _jsx("div", {
                className: "ProseMirror",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: generateHTML(initialState, extensions)
                }
            }) : /*#__PURE__*/ _jsx("div", {
                className: "ProseMirror",
                children: /*#__PURE__*/ _jsx("p", {
                    "data-placeholder": placeholder || "...",
                    className: "placeholder"
                })
            })
        })
    });
    if (editor) return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            editor && /*#__PURE__*/ _jsx(SelectionMenu, {
                editor: editor
            }),
            /*#__PURE__*/ _jsx(EditorWrapper, {
                className: className,
                children: /*#__PURE__*/ _jsx(EditorContent, {
                    editor: editor
                })
            })
        ]
    });
    return null;
};
export default Editor;
